import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Login from "./Login";
import Dashboard from "./pages/Dashboard"; // ダッシュボード画面のコンポーネントをインポート
import MaintenancePage from "./pages/MaintenancePage"; // メンテナンス画面の追加
import ClientRegistrationStep1 from "./pages/ClientRegistrationStep1"; // 顧客登録画面
import ClientRegistrationStep2 from "./pages/ClientRegistrationStep2";
//import ClientRegistrationStep3 from "./pages/ClientRegistrationStep3";
import ClientList from "./pages/clients/ClientList";
import ClientDetail from "./pages/clients/ClientDetail";
import ClientCsvUpload from "./pages/clients/ClientCsvUpload";
import SupplyRegistration from "./pages/supply/SupplyRegistration";
import SupplyHistory from "./pages/supply/SupplyHistory"; 
import GroupList from "./pages/group/GroupList"; 
import GroupEdit from "./pages/group/GroupEdit"; 
import SettingsHome from "./pages/setting/SettingsHome";
import SettingAccount from "./pages/setting/SettingsAccount";
import PlanSettings from "./pages/setting/PlanSettings";
import OAuthSuccess from "./pages/OAuthSuccess";
import Success from "./pages/setting/Success";
import Cancel from "./pages/setting/Cancel";
import SettingsShared from "./pages/setting/shared/SettingsShared";
import SettingsSharedCode from "./pages/setting/shared/SettingsSharedCode";
import SettingsSharedJoin from "./pages/setting/shared/SettingsSharedJoin";
import SettingsSharedRequests from "./pages/setting/shared/SettingsSharedRequests";
import MapRoute from "./pages/map/MapRoute";
import BaseLocationSettings from "./pages/map/BaseLocationSettings";
import SuggestedClients from "./pages/map/SuggestedClients";
import DataRegistration from "./pages/DataRegistration";
import ProductManagement from "./pages/product/ProductManagement"

// 🆕 データ分析機能の追加（既存）
import AnalysisHome from "./pages/analysis/AnalysisHome";
import ClientProductAnalysis from "./pages/analysis/ClientProductAnalysis";
// 🚀 新規追加：製品分析ダッシュボード
import ProductAnalysisDashboard from "./pages/analysis/ProductAnalysisDashboard";
// 🚀 新規追加：顧客製品選択画面（既存機能を分離）
import ClientProductSelect from "./pages/analysis/ClientProductSelect";

/**
 * ログインチェックを行い、未ログインなら`/login`へリダイレクト
 * @param {Object} children - 子コンポーネント
 */
const PrivateRoute = ({ children }) => {
    const token = sessionStorage.getItem("token"); // 🔄 sessionStorage に統一
    return token ? children : <Navigate to="/login" />; // 未ログインならログイン画面へ
};

/**
 * アプリ全体のルーティングを管理
 */
function App() {
    return (
        <Router>
            <Routes>
                {/* ログインページ（誰でもアクセス可能） */}
                <Route path="/login" element={<Login />} />

                {/* メンテナンスページ（直接アクセス可能 - デバッグ用） */}
                <Route path="/maintenance" element={<MaintenancePage />} />
                {/* ダッシュボード（ログイン必須） */}
                <Route path="/dashboard" element={<PrivateRoute><Dashboard /></PrivateRoute>} />
                
                 {/* 顧客登録画面（ログイン必須） */}
                <Route path="/client-registration-step1" element={<PrivateRoute><ClientRegistrationStep1 goToNextStep={() => {}} /></PrivateRoute>} />
                <Route path="/client-registration-step2" element={<PrivateRoute><ClientRegistrationStep2 goToNextStep={() => {}} /></PrivateRoute>} />
                
				<Route path="/clientList" element={<PrivateRoute><ClientList /></PrivateRoute>} />
				<Route path="/client/:id" element={<PrivateRoute><ClientDetail /></PrivateRoute>} />
				<Route path="/client-csv-upload" element={<PrivateRoute><ClientCsvUpload /></PrivateRoute>} />
    			<Route path="/supply-registration" element={<PrivateRoute><SupplyRegistration /></PrivateRoute>} />
    			<Route path="/supply-history" element={<PrivateRoute><SupplyHistory /></PrivateRoute>} />
    			<Route path="/group-List" element={<PrivateRoute><GroupList /></PrivateRoute>} />
    			<Route path="/group-edit/:id" element={<PrivateRoute><GroupEdit /></PrivateRoute>} />
    			<Route path="/setting-Home" element={<PrivateRoute><SettingsHome /></PrivateRoute>} />
				<Route path="/setting-Account" element={<PrivateRoute><SettingAccount /></PrivateRoute>} />
				<Route path="/settings/plan" element={<PrivateRoute><PlanSettings /></PrivateRoute>} />
				<Route path="/oauth-success" element={<OAuthSuccess />} />
				<Route path="/settings/success" element={<Success />} />
				<Route path="settings/cancel" element={<Cancel />} />
				<Route path="/settings/shared" element={<PrivateRoute><SettingsShared /></PrivateRoute>} />
				<Route path="/settings/shared/code" element={<PrivateRoute><SettingsSharedCode /></PrivateRoute>} />
				<Route path="/settings/shared/requests" element={<PrivateRoute><SettingsSharedRequests /></PrivateRoute>} />
				<Route path="/settings/shared/join" element={<PrivateRoute><SettingsSharedJoin /></PrivateRoute>} />
				<Route path="/map/route" element={<PrivateRoute><MapRoute /></PrivateRoute>} />
				<Route path="/map/base-location" element={<PrivateRoute><BaseLocationSettings /></PrivateRoute>} />
				<Route path="/map/suggestions" element={<SuggestedClients />} />
				
				<Route path="/data-registration" element={<PrivateRoute><DataRegistration /></PrivateRoute>} />
				<Route path="/product-registration" element={<PrivateRoute><ProductManagement /></PrivateRoute>} />
				
				{/* 🚀 修正：データ分析機能のルート */}
				<Route path="/analysis" element={<PrivateRoute><AnalysisHome /></PrivateRoute>} />
				{/* 🚀 新規追加：製品分析ダッシュボード（メイン機能） */}
				<Route path="/analysis/product-dashboard" element={<PrivateRoute><ProductAnalysisDashboard /></PrivateRoute>} />
				{/* 🚀 修正：顧客製品選択画面（既存機能を分離） */}
				<Route path="/analysis/client-product-select" element={<PrivateRoute><ClientProductSelect /></PrivateRoute>} />
				{/* 🚀 既存：顧客製品詳細分析（顧客製品選択画面から遷移） */}
				<Route path="/analysis/client-product" element={<PrivateRoute><ClientProductAnalysis /></PrivateRoute>} />
				
                {/* ルート（デフォルト）を `/login` にリダイレクト */}
                <Route path="*" element={<Navigate to="/login" />} />
            </Routes>
        </Router>
    );
}

export default App;